<template>
  <div class="pa-2 pa-sm-4">
    <v-btn @click="$router.back()" class="back-btn mb-2">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Administración de Reportes"
        :Cabecera="Cabecera"
        :loading="Loader"
        :Items="Reportes"
        :Excel="false"
        :Crear="false"
        @refrescar="refrescar"
        v-if="mostrartabla == true"
        :Loading="Loading"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/administradorreporte/tabla.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "AdministradorReportes",
  components: {
    tabla,
  },
  created() {
    this.cargarDatosAdministradorReportes();
  },
  data() {
    return {
      Cabecera: [
        {
          text: "Usuario / Autor",
          value: "name",
          align: "left",
        },
        {
          text: "Tipo de Reporte",
          value: "reporte",
          align: "left",
        },
        {
          text: "Última Actualización",
          value: "fecha",
          align: "center",
          width: 170,
        },
        {
          text: "Reporte y Observaciones",
          value: "iconos",
          align: "center",
          sortable: false,
          width: 170,
        },
        {
          text: "Estado",
          value: "estado",
          align: "center",
          width: 140,
        },
        {
          text: "Aprobación",
          value: "acciones",
          align: "center",
          sortable: false,
          width: 120,
        },
      ],
      loading: false,
      Loader: false,
      mostrartabla: true,
    };
  },
  methods: {
    ...mapActions("reporteconsolidado", ["cargarDatosAdministradorReportes"]),

    refrescar: async function () {
      await this.cargarDatosAdministradorReportes();
      this.mostrartabla = false;
      this.$nextTick().then(() => {
        this.mostrartabla = true;
      });
    },
  },
  computed: {
    ...mapState("reporteconsolidado", ["Reportes"]),
    ...mapState("reporteconsolidado", ["Loading"]),
  },
};
</script>
